





















import Vue from 'vue'
import { Component, Mixin, Lifecycle, Prop, p, Watch } from 'av-ts'
import { EventBus } from '@/eventbus'
import { VueUtils } from '@/mixins'
import { ILesson, languages } from '@/models'

@Component()
export default class LessonEdit extends Mixin(EventBus, VueUtils) {
  // lesson is passed by parent route
  @Prop lesson = p(Object) as ILesson

  lessonName = this.lesson ? this.lesson.name : ''

  async saveLesson() {
    if (this.lesson) {
      try {
        this.lesson.name = this.lessonName
        await this.$store.saveLesson(this.lesson)
        this.emitNotif('Lesson successfully saved !', {timeout: 2000})
      } catch (error) {
        EventBus.emitError(error)
      }
    }
  }
}
